<template>
  <ul class="contents-list"><slot></slot></ul>
</template>

<script>
export default {
  name: 'ContentsList'
};
</script>

<style lang="scss" scoped>
</style>
